import type { SVGProps } from 'react';
const SvgSyncAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#sync_alt_svg__a)">
      <path d="m22 8-4-4v3H3v2h15v3l4-4ZM2 16l4 4v-3h15v-2H6v-3l-4 4Z" />
    </g>
    <defs>
      <clipPath id="sync_alt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSyncAlt;
